import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
//primereact
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
//components
import Panel from "../../../../../components/panel/panel";
import Input from "../../../../../components/input/Input";
import NumberInput from "../../../../../components/input/NumberInput";
//services
import { getSimulations } from "../../../../../services/Contracts/getSimulations";
//utils
import { formatIsoDate } from "../../../../../utils/formatDate";
import { useAppContext } from "../../../../../context/AppContext";
import { useLocation, useNavigate } from "react-router-dom";

const Simulations = (id) => {
  const [showTable, setShowTable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [table, setTable] = useState();
  const { state } = useLocation();
  const navigate = useNavigate();
  const { nomenclatures } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);

  const form = useForm({
    shouldUnregister: false,
  });
  const errors = form.formState.errors;
  const onSubmit = async (data) => {
    const notification = toast.loading(
      "Por favor aguarde a consulta está sendo realizada..."
    );
    try {
      setLoading(true);
      const response = await getSimulations(id.id, data);
      response.map((r) => {
        r.created_at = formatIsoDate(r.created_at);
        return r;
      });
      toast.update(notification, {
        render: "Consulta Realizada!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      setLoading(false);
      setTable(response);
      setShowTable(true);
    } catch (e) {
      toast.update(notification, {
        render: "Houve um erro a buscar os dados, tente novamente",
        type: "error",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
    }

    setShowTable(true);
  };

  const columns = [
    { field: "id", header: "Nº Simulação" },
    { field: "name_cli", header: "Cliente" },
    { field: "created_at", header: "Data" },
    {
      field: "status",
      header: "Status",
      body: (rowData) => {
        let labelClass = "";
        let labelText = "";
        switch (rowData.status) {
          case 0:
            labelClass = "badge bg-danger";
            labelText = "Não enviado para proposta";
            break;
          case 1:
            labelClass = "badge bg-success";
            labelText = "Enviado para proposta";
            break;
          default:
        }
        return (
          <span
            className={labelClass}
            style={{
              fontSize: "10px",
              marginLeft: "10px",
              marginRight: "-100px",
            }}
          >
            {labelText}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <div className="row d-flex justify-content-between mb-3">
        <Panel title="Filtro de Dados">
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col-xl-4 col-md-5 mb-3">
                <Input
                  name="name_cli"
                  label="Nome do Cliente"
                  control={form.control}
                  errors={errors}
                />
              </div>
              <div className="col-xl-4 col-md-5 mb-3">
                <NumberInput
                  name="simulation_id"
                  control={form.control}
                  errors={errors}
                  label="Número Simulação"
                />
              </div>
              <div className="col-xl-1 col-md-2 text-center mt-3">
                <Button
                  type="submit"
                  icon="fa fa-search"
                  aria-label="Search"
                  loading={loading}
                  className={`rounded-3 py-2.5 w-100`}
                />
              </div>
            </div>
            <div className="d-flex justify-content-end"></div>
          </form>
        </Panel>
      </div>
      {showTable && (
        <div className="row">
          <Panel title={`Informações de Venda de ${nomenclature[1].value}`}>
            <>
              <hr className="my-4" />
              <div className="px-2 pb-3">
                <DataTable
                  rows={5}
                  paginator
                  stripedRows
                  showGridlines
                  sortMode="multiple"
                  selectionMode="single"
                  rowsPerPageOptions={[5, 25, 100]}
                  value={table}
                  emptyMessage={
                    <div style={{ textAlign: "center" }}>
                      Nenhuma Informação foi encontrada.
                    </div>
                  }
                  tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
                >
                  {columns.map((col) => (
                    <Column
                      sortable
                      key={col.field}
                      field={col.field}
                      header={col.header}
                      body={col.body}
                    />
                  ))}
                  <Column
                    header="Abrir Simulação"
                    body={(rowData) => (
                      <div className="text-center">
                        <button
                          className="btn btn-success btn-btn-sm"
                          onClick={() =>
                            navigate(`/simulation`, {
                              state: {
                                id: rowData.id,
                                enterpriseId: id,
                                name: state.name,
                              },
                            })
                          }
                        >
                          <i className="fa-solid fa-arrow-up-right-from-square"></i>
                        </button>
                      </div>
                    )}
                  />
                </DataTable>
              </div>
            </>
          </Panel>
        </div>
      )}
    </>
  );
};

export default Simulations;
